export default __webpack_public_path__ + "static/part1_3-d19385ab9c4444e4f6a8663208832029.png";